import React from 'react';
import PubSub from 'services/PubSub';
import TagManagerService from 'services/TagManager';
import { loginRegisterTxt } from 'config/translate/variables';
import style from './style.scss';//NOSONAR

const LoginRegister = () => {
    const openLogin = () => {
        PubSub.dispatch('login_open', {
            successCallback: () => {
                setTimeout(() => {
                    PubSub.dispatch('update_data_menu');
                }, 1);
            }
        });

        TagManagerService.clickHeader('Ingresa', 'Header mobile');
    }

    const openRegister = () => {
        PubSub.dispatch('register_open');
        TagManagerService.clickHeader('Regístrate', 'Header mobile');
    }


    return (
        <>
            <button onClick={openRegister} className='secundary-btn register-btn'>{loginRegisterTxt.register}</button>
            <button onClick={openLogin} className='primary-btn login-btn'>{loginRegisterTxt.login}</button>
        </>
    )
}

export default LoginRegister;
